import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ContributionIncentiveProgramService } from '../../../../../../services/contribution-incentive-program.service';
import { ToastrService } from '@openng/ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-delete-incentive-program-dialog',
  imports: [MatIcon,MatButtonModule],
  templateUrl: './delete-incentive-program-dialog.component.html',
  styleUrl: './delete-incentive-program-dialog.component.scss'
})
export class DeleteIncentiveProgramDialogComponent {

 constructor(
    private dialogRef: MatDialogRef<DeleteIncentiveProgramDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private incentiveProgramService: ContributionIncentiveProgramService,
    private toasterService: ToastrService,
    private spinner: NgxSpinnerService
  ) {
  }

    cancel(): void {
    this.dialogRef.close();
  }
  delete(): void {

     this.incentiveProgramService.deleteIncentiveProgram(this.data.formData.id).subscribe({
      next: (response) => {
        this.toasterService.success('Incentive Program deleted successfully');

        this.dialogRef.close();

      },
      error: (error) => {

        this.toasterService.error('Failed to delete Incentive Program','Error');
      }
      });
  }

}
